import { render } from "./RegistrationMAS.vue?vue&type=template&id=450e789a&scoped=true"
import script from "./RegistrationMAS.vue?vue&type=script&lang=js"
export * from "./RegistrationMAS.vue?vue&type=script&lang=js"

import "./RegistrationMAS.vue?vue&type=style&index=0&id=450e789a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450e789a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QTooltip,QBanner,QIcon,QSpinner});
